import { setScreenData } from 'cw-ui-core';

import { useNavigate } from 'react-router';
import { pageKeys } from 'src/asio-neon-components/Constants';

const setAlertScreenMessage = (type, title, message, positionSticky, screenKey) =>
    setScreenData(['activeAlertMessage'], { type, title, message, positionSticky }, screenKey);

export const getRouteFromPageKey = (pageKey, id) => {
    switch (pageKey) {
        case pageKeys.ADD_USER:
            return '/usersNew/create';

        case pageKeys.EDIT_USER:
            return `/users/edit/${id}`;

        default:
            return '/users';
    }
};

// CUSTOM HOOK: it will return 2 callback functions
// 1) redirectToPage: This function will take pageKey, id (if requied) and url (if we don't want to go with pageKey)
//                      This function can be used as evenetHandler on any action to jump to new route
// 2) goBack: This function will be used to go back in navigate on click of back button
export const useRouting = () => {
    const navigate = useNavigate();
    return {
        redirectToPage: (pageKey, id, url = '') => {
            const route = getRouteFromPageKey(pageKey, id);
            if (route || url) navigate(route ?? url);
        },
        goBack: () => {
            navigate(-1);
        },
    };
};

export default setAlertScreenMessage;
